/**
 * DB 컬럼 → 한글 라벨 사전.
 *
 * 기존 vanilla 코드의 chassis 매핑을 베이스로 확장.
 * 매핑 없는 컬럼은 grid/drawer 에서 그냥 컬럼명 그대로 표시.
 */
export const FIELD_LABEL: Record<string, string> = {
  // 공통 SKU/메타
  id: 'No.',
  option_part: '옵션 파트(SKU)',
  spare_part: '스페어 파트',
  assembly_part: '어셈블리 파트',
  factory_part: '팩토리 파트',
  description: '설명(정제)',
  description_raw: '설명(원문)',
  vendor: '제조사',
  oem_vendor: 'OEM 제조사',
  sku_segment: 'SKU 세그먼트',
  generation: '세대',
  notes: '비고',
  quickspec_version: 'QuickSpec 버전',
  created_at: '생성 시각',
  updated_at: '수정 시각',
  source_pdf: '출처 PDF',
  source_version: '출처 버전',

  // chassis
  model: '모델명',
  type: '타입',
  form_factor: '폼팩터',
  cpu_vendor: 'CPU 제조사',
  sku_type: 'SKU 유형',
  rack_unit: '랙 유닛(U)',
  ilo_version: '관리툴(iLO) 버전',
  max_cpu_sockets: '최대 CPU 소켓',
  chipset: '칩셋',
  memory_type: '메모리 규격',
  memory_dimm_slots: 'DIMM 슬롯 수',
  dimm_per_socket: '소켓당 DIMM',
  memory_max_capacity_gb: '최대 메모리(GB)',
  memory_protection: '메모리 보호',
  memory_max_speed_mts: '최대 메모리 속도(MT/s)',
  max_drive_bays_total: '총 드라이브 베이',
  psu_slot_count: 'PSU 슬롯 수',
  psu_redundant: 'PSU 이중화',
  psu_min_watt: 'PSU 최소 W',
  psu_max_watt: 'PSU 최대 W',
  pcie_total_slots: '총 PCIe 슬롯',
  pcie_generation: 'PCIe 세대',
  ocp_slot_count: 'OCP 슬롯 수',
  max_gpu_single_wide: '최대 GPU(싱글)',
  max_gpu_double_wide: '최대 GPU(더블)',
  embedded_nic_ports: '내장 NIC 포트',
  embedded_nic_speed: '내장 NIC 속도',
  height_cm: '높이(cm)',
  width_cm: '너비(cm)',
  depth_cm: '깊이(cm)',
  weight_min_kg: '최소 무게(kg)',
  weight_max_kg: '최대 무게(kg)',
  operating_temp_max_c: '동작 최대 온도(℃)',
  has_tpm: 'TPM 탑재',
  specs: '추가 스펙(JSON)',

  // chassis_storage_bay
  bay_position: '베이 위치',
  bay_type: '베이 타입',
  bay_count: '베이 수',
  is_default: '기본 구성',
  bay_raw: '베이 원문',

  // chassis_pcie_slot / chassis_ocp_slot
  chassis_id: '섀시 ID',
  chassis_part: '섀시 파트(SKU)',
  slot_number: '슬롯 번호',
  riser_position: '라이저 위치',
  bus_width: '버스 폭',
  connector_width: '커넥터 폭',
  requires_proc: '요구 프로세서',
  riser_part: '라이저 파트',
  ocp_version: 'OCP 버전',

  // chassis_compatible_parts
  category: '카테고리',
  required_or_optional: '필수/선택',
  min_qty: '최소 수량',
  max_qty: '최대 수량',
  compatibility_notes: '호환성 비고',

  // chassis_spec_event
  valid_from: '시작일',

  // cpu / cpu_model
  brand: '브랜드',
  family: '제품군',
  model_number: '모델 번호',
  suffix: '접미사',
  core_architecture: '코어 아키텍처',
  codename: '코드네임',
  launch_date: '출시일',
  cores: '코어',
  threads: '스레드',
  base_clock_ghz: '베이스 클럭(GHz)',
  turbo_clock_ghz: '터보 클럭(GHz)',
  all_core_turbo_ghz: '전체 코어 터보(GHz)',
  l2_cache_mb: 'L2 캐시(MB)',
  l3_cache_mb: 'L3 캐시(MB)',
  tdp_w: 'TDP(W)',
  max_turbo_power_w: '최대 터보 전력(W)',
  max_temp_c: '최대 온도(℃)',
  process_node: '공정',
  socket_type: '소켓',
  max_socket_config: '최대 소켓 구성',
  single_socket_capable: '싱글 소켓 가능',
  single_socket_only: '싱글 소켓 전용',
  upi_links: 'UPI 링크',
  upi_speed_gts: 'UPI 속도(GT/s)',
  memory_channels: '메모리 채널',
  memory_max_bandwidth_gbs: '메모리 대역폭(GB/s)',
  max_memory_per_socket_tb: '소켓당 최대 메모리(TB)',
  ecc_supported: 'ECC 지원',
  pcie_max_gen: '최대 PCIe 세대',
  pcie_lanes: 'PCIe 레인',
  cxl_supported: 'CXL 지원',
  die_type: '다이 타입',
  hbm_capacity_gb: 'HBM 용량(GB)',
  speed_select_enabled: 'Speed Select',
  sgx_enclave_size_gb: 'SGX 엔클레이브(GB)',
  amx_supported: 'AMX 지원',
  avx512_supported: 'AVX-512 지원',
  intel_tdt_supported: 'Intel TDT',
  suffix_meaning: '접미사 의미',
  workload_category: '워크로드',
  liquid_cooling_required: '액랭 필수',
  intel_launch_price_usd: 'Intel 출시가($)',
  oem_bundle: 'OEM 번들(JSON)',

  // gpu
  mfg_part_number: '제조사 파트번호',
  architecture: '아키텍처',
  form_factor_raw: '폼팩터(원문)',
  slot_width: '슬롯 폭',
  height_form: '높이 폼',
  length_form: '길이 폼',
  power_connector: '전원 커넥터',
  tdp_w_min: 'TDP 최소(W)',
  tdp_w_max: 'TDP 최대(W)',
  total_power_w: '총 전력(W)',
  recommended_psu_w: '권장 PSU(W)',
  memory_gb: '메모리(GB)',
  memory_bw_gb_s: '메모리 대역폭(GB/s)',
  memory_bus_width_bit: '메모리 버스(bit)',
  tensor_cores: '텐서 코어',
  rt_cores: 'RT 코어',
  fp64_tflops: 'FP64(TFLOPS)',
  fp32_tflops: 'FP32(TFLOPS)',
  fp16_tflops: 'FP16(TFLOPS)',
  perf_extra: '추가 성능(JSON)',
  interface: '인터페이스',
  pcie_gen: 'PCIe 세대',
  supports_nvlink: 'NVLink 지원',
  nvlink_generation: 'NVLink 세대',
  nvlink_bandwidth_gbs: 'NVLink 대역폭(GB/s)',
  mig_support: 'MIG 지원',
  gpu_count: 'GPU 수',
  cooling_type: '냉각 방식',
  display_outputs: '디스플레이 출력(JSON)',

  // memory
  capacity_gb: '용량(GB)',
  speed_mts: '속도(MT/s)',
  rank_count: '랭크',
  dram_width: 'DRAM 폭',
  cas_latency: 'CAS Latency',
  dram_density_gb: 'DRAM 밀도(GB)',
  voltage_v: '전압(V)',
  is_smart_memory: 'Smart Memory',

  // ssd / hdd
  interface_speed: '인터페이스 속도',
  carrier_type: '캐리어 타입',
  workload_class: '워크로드 클래스',
  endurance_dwpd: 'DWPD',
  model_name: '제품명',
  manufacturer: '제조사(모델)',
  controller_gen: '컨트롤러 세대',
  performance_class: '성능 등급',
  seq_read_mib_s: '순차 읽기(MiB/s)',
  seq_write_mib_s: '순차 쓰기(MiB/s)',
  random_read_iops_4k: '4K 랜덤 읽기(IOPS)',
  random_write_iops_4k: '4K 랜덤 쓰기(IOPS)',
  random_70_30_iops_4k: '4K 70:30(IOPS)',
  random_50_50_iops_4k: '4K 50:50(IOPS)',
  random_read_latency_us: '랜덤 읽기 지연(μs)',
  random_write_latency_us: '랜덤 쓰기 지연(μs)',
  power_idle_w: '유휴 전력(W)',
  power_random_read_w: '랜덤 읽기 전력(W)',
  power_random_write_w: '랜덤 쓰기 전력(W)',
  power_seq_read_w: '순차 읽기 전력(W)',
  power_seq_write_w: '순차 쓰기 전력(W)',
  power_random_rw_w: '랜덤 RW 전력(W)',
  power_max_w: '최대 전력(W)',
  z_height_mm: 'Z 높이(mm)',
  is_sed: 'SED',
  fips_level: 'FIPS 등급',
  is_multi_vendor: '멀티벤더',
  edsff_class: 'EDSFF 클래스',
  rpm: 'RPM',
  is_helium: '헬륨',
  sector_format: '섹터 포맷',
  is_ise: 'ISE',
  seq_throughput_mib_s: '순차 처리량(MiB/s)',
  random_read_iops_128k: '128K 랜덤 읽기',
  random_70_30_iops_128k: '128K 70:30',
  random_50_50_iops_128k: '128K 50:50',
  height_mm: '높이(mm)',
  width_mm: '너비(mm)',
  depth_mm: '깊이(mm)',

  // network_adapter / network_adapter_model
  chip_model: '칩 모델',
  asic_model: 'ASIC 모델',
  interface_type: '인터페이스 타입',
  speed_gbps_max: '최대 속도(Gbps)',
  speed_gbps_min: '최소 속도(Gbps)',
  port_count: '포트 수',
  connector_type: '커넥터',
  power_typical_w: '일반 전력(W)',
  power_max_w_card: '최대 전력(W)',
  supports_uefi_pxe: 'UEFI PXE',
  supports_legacy_bios_pxe: 'Legacy PXE',
  supports_wol: 'WoL',
  supports_iscsi_boot: 'iSCSI Boot',
  rdma_protocols: 'RDMA 프로토콜',
  tunnel_offload: '터널 오프로드',
  supports_sriov: 'SR-IOV',
  sriov_vf_count: 'SR-IOV VF 수',
  supports_npar: 'NPAR',
  npar_pf_count: 'NPAR PF 수',
  root_of_trust_type: 'Root of Trust',
  supports_secure_boot: '시큐어 부트',
  supports_audit_log: '감사 로그',
  supports_sanitization: '데이터 소거',
  supports_authenticated_updates: '인증된 업데이트',
  card_profile: '카드 프로파일',
  min_server_generation: '최소 서버 세대',

  // hba / hba_model
  series: '시리즈',
  chip_family: '칩 패밀리',
  media_type: '미디어 타입',
  fc_protocols: 'FC 프로토콜',
  supports_smart_san: 'Smart SAN',
  supports_t10_pi: 'T10 PI',
  supports_npiv: 'NPIV',
  supports_bb_credit_recovery: 'BB Credit Recovery',
  supports_fec: 'FEC',
  supports_uscm: 'USCM',
  supports_fdmi: 'FDMI',
  supports_fa_wwn: 'FA-WWN',
  supports_d_port_diagnostics: 'D-Port 진단',
  supports_active_health: 'Active Health',
  supports_secure_firmware: '시큐어 펌웨어',
  includes_sfp: 'SFP 포함',
  bracket_type: '브래킷 타입',

  // raid_controller
  ports_raw: '포트(원문)',
  internal_sas_lanes: '내부 SAS 레인',
  host_interface: '호스트 인터페이스',
  cache_size_gb: '캐시(GB)',
  energy_pack_required: 'Energy Pack 필요',
  supports_sas: 'SAS 지원',
  supports_sata: 'SATA 지원',
  supports_nvme: 'NVMe 지원',
  sas_speed_gbps: 'SAS 속도(Gbps)',
  sata_speed_gbps: 'SATA 속도(Gbps)',
  nvme_speed_gbps: 'NVMe 속도(Gbps)',
  storage_protocol_raw: '스토리지 프로토콜(원문)',
  raid_levels: 'RAID 레벨',
  supports_mixed_mode: '혼합 모드',
  ssd_acceleration: 'SSD 가속',
  stripe_size_max_kb: '최대 스트라이프(KB)',
  supports_hot_spare: 'Hot Spare',
  hot_spare_features: 'Hot Spare 기능(JSON)',
  supports_oce: 'OCE',
  supports_smart: 'SMART',
  supports_patrol_read: 'Patrol Read',
  supports_multipathing: '멀티패싱',
  supports_load_balancing: '로드밸런싱',
  supports_mixed_drives: '혼합 드라이브',
  auto_resume_on_power_loss: '전원 복구 시 재개',
  supports_uefi: 'UEFI',
  supports_legacy_boot: 'Legacy Boot',
  supports_oneview: 'OneView',
  array_features: '어레이 기능(JSON)',
  logical_drive_features: 'LD 기능(JSON)',
  max_physical_drives: '최대 PD',
  max_logical_drives: '최대 LD',
  max_nvme_devices: '최대 NVMe',
  supports_sed: 'SED 지원',
  supports_spdm: 'SPDM',
  silicon_root_of_trust: 'Silicon RoT',
  supports_safestore: 'SafeStore',
  bandwidth_mbs: '대역폭(MB/s)',
  max_iops_read: '최대 읽기 IOPS',
  max_iops_raid5_write: 'RAID5 쓰기 IOPS',
  warranty_years: '보증 연수',

  // cache_battery
  product_line: '제품군',
  cable_length_mm: '케이블 길이(mm)',
  capacity_w: '용량(W)',
  max_joules: '최대 J',
  max_supported_devices: '최대 장치 지원',
  charge_time_minutes: '충전 시간(분)',
  supports_nvdimm: 'NVDIMM 지원',
  is_class9_dangerous: 'Class 9 위험물',
  high_temp_capable: '고온 사용 가능',

  // power_supply
  input_type: '입력 타입',
  input_voltage_min: '입력 전압 최소',
  input_voltage_max: '입력 전압 최대',
  input_voltage_raw: '입력 전압(원문)',
  output_wattage_min: '출력 최소(W)',
  output_wattage_max: '출력 최대(W)',
  efficiency_rating: '효율 등급',
  efficiency_pct: '효율(%)',
  weight_kg: '무게(kg)',
  is_hot_plug: 'Hot Plug',

  // riser
  position: '위치',
  chassis_model: '섀시 모델',
  is_nebs_compliant: 'NEBS 준수',
  requires_cpu2: 'CPU2 필요',
  requires_cable_kit: '케이블 키트 필요',

  // rail_kit
  rail_type: '레일 타입',
  server_form_factor: '서버 폼팩터(U)',
  supports_4post_rack: '4-post 랙',
  supports_2post_rack: '2-post 랙',

  // drive_tray
  is_hot_plug_tray: 'Hot Plug',
  is_tool_less: '툴리스',

  // heatsink
  min_tdp_w: '최소 TDP(W)',
  max_tdp_w: '최대 TDP(W)',
  is_low_profile: '저프로파일',
  supports_q_series: 'Q-Series 지원',
  requires_dlc_module: 'DLC 모듈 필요',

  // fan
  fan_type: '팬 타입',
  chassis_default_count: '기본 팬 수',
  chassis_max_count: '최대 팬 수',
  is_redundant: '이중화',

  // accessory
  parent_category: '상위 카테고리',
  parent_part: '상위 파트',

  // pre_configured_model
  config_type: '구성 유형',
  base_chassis_id: '베이스 섀시 ID',
  cpu_part: 'CPU 파트',
  cpu_count: 'CPU 수',
  memory_part: '메모리 파트',
  memory_capacity_gb: '메모리 용량(GB)',
  memory_dimm_count: 'DIMM 수',
  memory_speed_mts: '메모리 속도(MT/s)',
  storage_controller: '스토리지 컨트롤러',
  drive_part: '드라이브 파트',
  drive_count: '드라이브 수',
  psu_part: 'PSU 파트',
  psu_count: 'PSU 수',
  network_part: '네트워크 파트',
  region_code: '리전 코드',
  eol_target_date: 'EOL 예정일',

  // seed_conflict_log
  table_name: '테이블',
  column_name: '컬럼',
  old_value: '이전 값',
  new_value: '새 값',
  chassis_source: '섀시 소스',
  detected_at: '감지 시각',
  resolved: '해결됨',
  resolution: '해결 방안',
  resolution_notes: '해결 비고',
  resolved_by: '해결자',
  resolved_at: '해결 시각',
};

/**
 * 컬럼 키에 대응되는 한글 라벨을 반환.
 * 매핑이 없으면 키를 그대로 반환.
 */
export function labelFor(key: string): string {
  return FIELD_LABEL[key] ?? key;
}
